import BaseModelAPI from '../BaseModelAPI';

export default class PickingForDeliveryDetail extends BaseModelAPI {
	static entity = 'pickingfordeliverydetail';
	static entityName = 'pickingfordeliverydetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.pickingForDeliveryId = '';
			this.pickingForDelivery = {};
			this.deliveryInstructionDetailId = '';
			this.deliveryInstructionDetail = {};
			this.planQty = 0;
			this.actualQty = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.remark = '';
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}